import {
  Brand,
  Practice,
  SchedulingEventReason,
} from '@principle-theorem/principle-core';
import {
  ISchedulingEventReason,
  type IOrganisation,
} from '@principle-theorem/principle-core/interfaces';
import {
  Firestore,
  toQuery,
  toTimestamp,
  type Query,
  type WithRef,
} from '@principle-theorem/shared';
import { BigQueryJobName } from '../../job-names';
import { ISchedulingEventReasonWriteTopicData } from '../../topic-data/topic-data';
import {
  BasicBigQuerySyncHandler,
  IBigQuerySyncRequest,
} from '../big-query-sync';

export class BigQuerySchedulingEventReasonSyncHandler extends BasicBigQuerySyncHandler<
  ISchedulingEventReason,
  ISchedulingEventReasonWriteTopicData
> {
  readonly bigQueryJobName = BigQueryJobName.SchedulingEventReasonWrite;
  getQuery(request: IBigQuerySyncRequest): Query<ISchedulingEventReason> {
    const brandRef = Practice.brandRef({ ref: request.practiceRef });
    return toQuery(Brand.cancellationReasonCol({ ref: brandRef }));
  }

  async getTopicData(
    schedulingEventReason: WithRef<ISchedulingEventReason>
  ): Promise<ISchedulingEventReasonWriteTopicData> {
    const brandRef = SchedulingEventReason.brandRef(schedulingEventReason);
    const organisationRef = Firestore.getParentDocRef<IOrganisation>(brandRef);
    return {
      organisation: await Firestore.getDoc(organisationRef),
      brand: await Firestore.getDoc(brandRef),
      schedulingEventReason,
      timestamp: toTimestamp(),
    };
  }
}
